import { Grid } from "theme-ui";
import { Themed } from "@theme-ui/mdx";
import PostCard from "../components/PostCard";
import Loading from "./Loading";

const PostList = ({ posts, collection, onClick, loading }) => {
  if (posts && posts.length) {
    return (
      <Grid gap={["md", null, "lg"]} columns={[1, null, 2, 3]}>
        {posts.map((post) => (
          <PostCard
            collection={collection}
            post={post}
            key={post.id}
            onClick={(e) => {
              if (onClick) {
                e.preventDefault();
                onClick(post);
              }
            }}
          />
        ))}
      </Grid>
    );
  } else if (loading) {
    return <Loading />;
  } else {
    return <Themed.p>There are no {collection} posts yet</Themed.p>;
  }
};

export default PostList;
